import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import api from "../Api";
import iconId from "../assets/icon/arrow/freccia.png";
import ACTIVITY_OPTIONS from "./utils/ActivityOptions"; // <--- aggiungi questa riga

export default function ReportBox() {
  const [closedActivities, setClosedActivities] = useState([]);
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const getCurrentMonth = () => {
    const raw = new Date().toLocaleDateString("it-IT", {
      month: "long",
      year: "numeric",
    });
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  };

  useEffect(() => {
    if (!user) return;
    const fetchClosedActivities = async () => {
      try {
        let endpoint = "/activity/activities";
        let params = {};
        if (user && user.role === "rup") {
          endpoint = "/activity/worksite-activities";
          params.status = "closed";
          params.worksite = user.worksite; // <-- aggiungi questo parametro
        }
        const res = await api.get(endpoint, { params });
        // Se non sei RUP, filtra lato frontend come prima
        const filtered = user && user.role === "rup"
          ? res.data
          : res.data.filter((activity) => activity.status === "closed");
        const sorted = filtered.sort((a, b) => new Date(b.end_date) - new Date(a.end_date));
        const sliced = sorted.slice(0, 5);

        const activitiesWithUser = await Promise.all(
          sliced.map(async (activity) => {
            if (!activity.operator_id) return { ...activity, operatorName: "N/A" };
            try {
              const userRes = await api.get(`/user/${activity.operator_id}`);
              const { firstName, lastName } = userRes.data;
              return { ...activity, operatorName: `${firstName} ${lastName}` };
            } catch (e) {
              console.warn("Errore utente:", e);
              return { ...activity, operatorName: "N/A" };
            }
          })
        );

        setClosedActivities(activitiesWithUser);
      } catch (error) {
        console.error("Errore nel recupero delle attività chiuse:", error);
      }
    };

    fetchClosedActivities();
  }, [user]);

  const goToActivity = (id) => {
    navigate(`/activity-details/${id}`);
  };

  const goToAllClosed = () => {
    navigate("/closed-activity");
  };

  return (
    <div className="w-full h-full bg-primary rounded-2xl shadow p-4 text-white border-2 border-secondary flex flex-col">
      {/* Header con "Vedi tutte" */}
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-semibold">Report attività</h2>
        <button
          onClick={goToAllClosed}
          className="text-sm text-green-400 underline hover:text-green-600 transition"
        >
          Vedi tutte
        </button>
      </div>

      <p className="text-sm text-gray-300 mb-4">{getCurrentMonth()}</p>

      <ul className="space-y-4 overflow-y-auto pr-1 flex-1">
        {closedActivities.length === 0 ? (
          <li className="text-sm text-gray-400">Nessuna attività chiusa</li>
        ) : (
          closedActivities.map((activity) => {
            const endDate = new Date(activity.end_date);
            const time = endDate.toLocaleTimeString("it-IT", {
              hour: "2-digit",
              minute: "2-digit",
            });
            const date = endDate.toLocaleDateString("it-IT");

            return (
              <li
                key={activity.id}
                onClick={() => goToActivity(activity.id)}
                className="flex items-center justify-between gap-4 border-b border-white/10 pb-4 text-sm cursor-pointer hover:bg-white/5 transition"
              >
                <div className="flex gap-4">
                  <div className="flex flex-col items-start text-xs text-gray-300 min-w-[70px]">
                    <span className="font-mono">{time}</span>
                    <span>{date}</span>
                  </div>

                  <div className="flex flex-col">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-semibold text-white">
                        {getActivityLabel(activity.activity_names?.[0]) || "Attività"}
                      </span>
                      <span className="text-green-500 text-xs font-semibold">Chiusa</span>
                    </div>
                    <span className="text-xs text-gray-400">
                      Operatore: {activity.operatorName || "N/A"}
                    </span>
                  </div>
                </div>

                <img
                  src={iconId}
                  alt="Vai all'attività"
                  className="w-5 h-5 opacity-70 hover:opacity-100 transition"
                />
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
}


// Funzione per ottenere il label dall'opzione
const getActivityLabel = (value) => {
  const option = ACTIVITY_OPTIONS.find((opt) => opt.value === value);
  return option ? option.label : value;
};
